/* Native dialog supplies focus containment and Escape dismissal. No social embeds or tracking. */
if (!customElements.get('piex-follow')) {
  customElements.define('piex-follow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.dialog = this.querySelector('dialog');
      this.host = this.closest('piex-motion');
      if (!this.dialog || !this.host) return;
      this.host.addEventListener('click', event => {
        const opener = event.target.closest('[data-follow-open]');
        if (opener) {
          this.opener = opener;
          this.host.querySelectorAll('video').forEach(video => video.pause());
          if (!this.dialog.open) this.dialog.showModal();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-follow-close]')) this.dialog.close();
        else if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.opener?.isConnected && document.documentElement.dataset.piexMode === 'standard') this.opener.focus({preventScroll:true});
      }, options);
      this.modeObserver = new MutationObserver(() => {
        if (document.documentElement.dataset.piexMode !== 'standard' && this.dialog.open) this.dialog.close();
      });
      this.modeObserver.observe(document.documentElement, {attributes:true, attributeFilter:['data-piex-mode']});
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort();
      this.modeObserver?.disconnect();
    }
  });
}
